import { defineStore } from 'pinia'

export const useSecurityStore = defineStore('security', {
    state: () => ({
        securitySettings: [],
        securitySettingsInitialState: [],
        currentDeviceId: null
    }),
    
    actions: {
        setSecuritySettings(settings) {
            this.securitySettings = settings;
        },
        getSecuritySettings() {
            return this.securitySettings;
        },
        setCurrentDeviceId(deviceId) {
            this.currentDeviceId = deviceId;
        },
        getCurrentDeviceId() {
            return this.currentDeviceId;
        },
        setSecuritySettingsInitialState(settings) {
            this.securitySettingsInitialState = JSON.parse(JSON.stringify(settings));
        },
        getSecuritySettingsInitialState() {
            return this.securitySettingsInitialState;
        },
        getDefaultSettings() {
            return {
                safesearch: true,
                youtube_restricted: true,
                nextdns_list: true,
                oisd: false,
                adguard_mobile: false,
                secure_google: true,
                block_trackers: false
            };
        }
    }
})